// extracted by mini-css-extract-plugin
export default {"smallHouseSquare":"SmallHouseItem_smallHouseSquare__3-cgp","eviBottomSquare":"SmallHouseItem_eviBottomSquare__VhWUD","frameIcon":"SmallHouseItem_frameIcon__M-Ajc"};